<template>
  <div>
    <!-- 装修模块-图片管理库 -->
    <myPopup title="图片管理" :flag="isShow" width="583" @close="close">
      <div class="photoGallery">
        <div class="tabWrap">
          <div
            class="tabItem"
            :class="{ active: tabActive == 1 }"
            @click="tabActive = 1"
          >
            上传图片
          </div>
          <div
            v-if="!uploadBack"
            class="tabItem"
            :class="{ active: tabActive == 2 }"
            @click="tabActive = 2"
          >
            图片库
          </div>
          <i class="line"></i>
        </div>
        <!-- 上传图片 -->
        <div v-show="tabActive == 1">
          <!-- 上传区域 -->
          <div class="row">
            <div class="text">
              <i>*</i>
              上传图片：
            </div>
            <div class="rowItem">
              <el-upload
                ref="upload"
                action="#"
                list-type="picture-card"
                :on-change="handleChange"
                :on-exceed="onExceed"
                :file-list="fileList"
                :auto-upload="false"
                :limit="1"
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url"
                    alt=""
                  />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file.url)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      class="el-upload-list__item-delete"
                      @click="handleDownload(file)"
                    >
                      <i class="el-icon-download"></i>
                    </span>
                    <span
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <div v-if="uploadBack" class="tips">
                <i class="el-icon-warning"></i>
                请上传宽度750px，高度为265px的图片，单张容量最大3MB
              </div>
              <div v-else class="tips">
                <i class="el-icon-warning"></i>
                请上传宽度100px，高度为100px的图片，单张容量最大3MB
              </div>
            </div>
          </div>
          <div v-if="!uploadBack" class="row">
            <div class="text">
              <i>*</i>
              图片名称：
            </div>
            <div class="rowItem">
              <el-input
                placeholder="请输入"
                v-model="form.imageName"
              ></el-input>
              <div class="tips">
                <i class="el-icon-warning"></i>
                若不设置则使用上传的图片名称
              </div>
            </div>
          </div>
        </div>

        <!-- 图片库 -->
        <div v-show="tabActive == 2">
          <div class="nav">
            <span :class="{ active: navActive == 1 }" @click="switchNav(1)"
              >系统图标</span
            >
            <span :class="{ active: navActive == 2 }" @click="switchNav(2)"
              >自定义</span
            >
          </div>
          <div class="imgWrap">
            <div
              class="imgItem"
              :class="{ active: selectImg.id == item.id }"
              v-for="item in imgList"
              :key="item.id"
              @click="handleSelectImg(item)"
            >
              <img v-if="item.imageUrl" :src="item.imageUrl" alt="" />
              <div class="mask">
                <div class="handle">
                  <i
                    class="el-icon-zoom-in"
                    @click="handlePictureCardPreview(item.imageUrl)"
                  ></i>
                  <i
                    v-if="navActive == 2"
                    class="el-icon-delete"
                    @click="handleDeleteImage(item.id)"
                  ></i>
                </div>
              </div>
            </div>
          </div>
          <el-pagination
            class="pagination"
            @current-change="handleCurrentChange"
            :page-size="8"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>

        <footer class="footerBtns">
          <button class="cancel" @click="close">取消</button>
          <button class="confirm" @click="confirmUpload">确认</button>
        </footer>
      </div>
    </myPopup>

    <!-- 图片放大弹窗 -->
    <myPopup :flag="dialogVisible" @close="dialogVisible = false">
      <img class="enlarge" :src="dialogImageUrl" alt="" />
    </myPopup>
  </div>
</template>

<script>
import myPopup from "./myPopup";
import { mapState, mapMutations } from "vuex"
import {
  uploadImage,
  addImage,
  getList,
  delImage,
} from "@/api/sellerImageController";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    uploadBack: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    myPopup,
  },
  data() {
    return {
      tabActive: 1,
      fileList: [],
      // 图片放大弹窗控制
      dialogVisible: false,
      dialogImageUrl: "",
      // 往图片库添加请求表单
      form: {
        imageName: "",
        // 当前上传图片的真实url
        imageUrl: "",
        type: 2,
      },
      // 图片库下的img列表
      imgList: [],
      // 存储图片库下的选中img
      selectImg: {
        id: -1,
      },
      // 图片库下的切换nav
      navActive: 1,
      // 图片库列表请求表单
      listForm: {
        current: 1,
        size: 8,
        type: 1,
      },
      total: 0,
    };
  },
  created() {
    this.getImgList();
  },
  methods: {
    ...mapMutations([
      "replaceUploadIcon"
    ]),
    // 获取图片列表
    getImgList() {
      getList(this.listForm).then((res) => {
       
        if (res && res.code == 1) {
          this.total = Number(res.data.total);
          this.imgList = res.data.records;
        }
      });
    },

    // 上传图片变化事件
    handleChange(file, fileList) {
      const isLt3M = file.size < 1024 * 1024 * 3;
      if (this.uploadBack) {
         const isSize = new Promise(function(resolve,reject) {
            let width = 750
            let height = 265
            // let _URL = window.URL || window.webkitURL
            var img = new Image()
            img.onload = function() {
              let valid = img.width == width && img.height == height
                // console.log(valid);
              valid ? resolve() : reject();
              // resolve()
            }
            img.src = file.url
            console.log(img);
  
        }).then(() => {
          // return file;

          this.fileList = fileList;
          this.$refs.upload.$children[1].$el.style.display = "none";
          this.form.imageName = file.name;
          let formdata = new FormData();
          formdata.append("file", file.raw);
          uploadImage(formdata).then((res) => {
            // 获取图片真实url
            // this.form.imageUrl = res && res.data;
            if(res && res.code == 1) {
              this.$message.success('上传图片成功')
            //     // this.replaceUploadIcon(res.data)
            }
          });
          
        }).catch(()=>{
  
          this.$message.error("上传图片尺寸必须是750*265");
          this.$refs.upload.clearFiles();
  
        })
      }else{

        const isSize = new Promise(function(resolve,reject) {
            let width = 100
            let height = 100
            // let _URL = window.URL || window.webkitURL
            var img = new Image()
            img.onload = function() {
              let valid = img.width == width && img.height == height
                // console.log(valid);
              valid ? resolve() : reject();
              // resolve()
            }
            img.src = file.url
            console.log(img);
  
        }).then(() => {
            // return file;
          if (!isLt3M) {
            this.$message.error("上传图片大小不能超过 3MB");
            this.$refs.upload.clearFiles();
          } else {
            this.fileList = fileList;
            this.$refs.upload.$children[1].$el.style.display = "none";
            this.form.imageName = file.name;
            let formdata = new FormData();
            formdata.append("file", file.raw);
            uploadImage(formdata).then((res) => {
              // 获取图片真实url
              this.form.imageUrl = res && res.data;
            });
          }
        }).catch(()=>{
  
          this.$message.error("上传图片尺寸必须是100*100");
          this.$refs.upload.clearFiles();
  
        })
      }
     
    
      
    },
    // 放大图片
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log("下载图片");
    },
    // 删除上传的图片
    handleRemove(file) {
      this.fileList = [];
      this.$refs.upload.clearFiles();
      this.imageName = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    onExceed() {
      this.$message.warning("请先删除当前上传图片");
    },
    // 切换图片库下的nav
    switchNav(v) {
      this.navActive = v;
      this.listForm.type = v;
      this.getImgList();
    },
    // 图片库的图片点击
    handleSelectImg(item) {
      this.selectImg = item;
    },
    // 确定
    confirmUpload() {
      if(this.uploadBack){
        // this.replaceUploadIcon(res.data)
        this.$emit("close", this.selectImg);
        return
      }
      const type = this.tabActive;
      if (type == 1) {
        // 处于上传图片
        addImage(this.form).then((res) => {
          // 往图片库添加请求
          if (res && res.code == 1) {
            this.$message.success("添加成功");
          }
        });
        if (!this.form.imageUrl) {
          this.$message.warning("请先上传图片");
          return;
        }
        this.$emit("close", this.form);
        this.resetData();
      } else {
        // 处于图片库
        if (!this.selectImg) {
          this.$message.warning("请先选中图片");
          return;
        }
        this.$emit("close", this.selectImg);
        this.resetData();
      }
    },
    // 删除自定义图片
    handleDeleteImage(id) {
      delImage(id).then((res) => {
        if (res && res.code == 1) {
          this.$message.success("删除成功");
          this.getImgList();
        }
      });
    },
    // 分页变化
    handleCurrentChange(val) {
      this.listForm.current = val;
      this.getImgList();
    },
    // 重置数据
    resetData() {
      this.form = {
        imageName: "",
        // 当前上传图片的真实url
        imageUrl: "",
        type: 2,
      };
      this.listForm = {
        current: 1,
        size: 8,
        type: 1,
      };
      this.selectImg = {
        id: -1,
      };
      (this.navActive = 1), (this.tabActive = 1);
      this.fileList = [];
      this.$refs.upload.$children[1].$el.style.display = "block";
      this.$refs.upload.clearFiles();
    },
    // 取消
    close() {
      this.$emit("close", false);
    },
  },
};
</script>

<style scoped lang="scss">
.photoGallery {
  box-sizing: border-box;
  padding: 20px 30px 30px;
  z-index: 10000;
  .tabWrap {
    display: flex;
    color: #666;
    font-size: 14px;
    font-weight: 400;
    .tabItem {
      width: 106px;
      height: 36px;
      line-height: 35px;
      border: 1px solid #dddddd;
      border-radius: 2px 2px 0px 0px;
      text-align: center;
      cursor: pointer;
      &.active {
        border-bottom: none;
        color: #fe4d45;
        font-weight: 500;
        border-top: 3px solid #fe4d45;
        border-radius: 4px 4px 0px 0px;
      }
    }
    .line {
      flex: 1;
      border-bottom: 1px solid #ddd;
    }
  }
  .row {
    display: flex;
    margin-top: 30px;
    .text {
      width: 100px;
      color: #333;
      font-size: 14px;
      i {
        color: #ff3a27;
        margin-top: 4px;
      }
    }
    .rowItem {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      /deep/ .el-upload--picture-card {
        width: 280px;
      }
      /deep/ .el-input__inner {
        height: 32px;
        transform: translateY(-25%);
      }
      /deep/ .el-upload-list--picture-card .el-upload-list__item {
        width: 280px;
      }
      .tips {
        margin-top: 10px;
        color: #999;
        font-size: 14px;
        i {
          color: #ff3a27;
          margin-right: 4px;
        }
      }
    }
  }
  .nav {
    display: flex;
    align-items: center;
    margin-top: 16px;
    span {
      width: 80px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      border: 1px solid #cccccc;
      border-radius: 2px;
      color: #333;
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
      &:first-child {
        margin-right: 12px;
      }
      &.active {
        border: 1px solid #fe4d45;
        color: #fe4d45;
      }
    }
  }
  .imgWrap {
    box-sizing: border-box;
    max-height: 230px;
    padding: 20px;
    margin-top: 16px;
    background-color: #fafafa;
    text-align: left;
    cursor: pointer;
    .imgItem {
      position: relative;
      display: inline-block;
      width: 84px;
      height: 84px;
      border: 1px dashed #ccc;
      border-radius: 2px;
      overflow: hidden;
      margin-right: 18px;
      background-color: #fff;
      &.active {
        border: 1px solid #fe4d45;
      }
      &:hover {
        .mask {
          opacity: 1;
        }
      }
      &:nth-child(n + 5) {
        margin-top: 20px;
      }
      img {
        width: 82px;
        height: 82px;
        border-radius: 50%;
      }
      .mask {
        opacity: 0;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        transition: all 0.3s;
        .handle {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          font-size: 20px;
          font-weight: bold;
          i {
            margin-right: 10px;
            &:last-child {
              margin: 0;
            }
          }
        }
      }
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
  .footerBtns {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 10px;
    transform: translateY(10px);
    .cancel {
      width: 98px;
      height: 32px;
      line-height: 32px;
      border: 1px solid #cccccc;
      margin-right: 12px;
      border-radius: 3px;
      color: #999;
      font-size: 14px;
    }
    .confirm {
      width: 98px;
      height: 32px;
      line-height: 32px;
      border-radius: 3px;
      background-color: #fe4d45;
      color: #fff;
      font-size: 14px;
    }
  }
}
.enlarge {
  width: 100%;
  margin-top: 20px;
}
</style>
